import { render, staticRenderFns } from "./updateModal.vue?vue&type=template&id=06381a0a&scoped=true"
import script from "./updateModal.vue?vue&type=script&lang=js"
export * from "./updateModal.vue?vue&type=script&lang=js"
import style0 from "./updateModal.vue?vue&type=style&index=0&id=06381a0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06381a0a",
  null
  
)

export default component.exports